<template>
  <div>
    <header class="header">
      <nav class="navbar">
        <ul>
          <img src="/assets/logoMirindra.PNG" alt="logo" class="logo" />
          <li><router-link to="/home">Accueil</router-link></li>
          <li class="dropdown">
            <a href="#" class="dropbtn">Articles</a>
            <ul class="dropdown-content">
              <li><router-link to="/add-article">Ajouter un article</router-link></li>
              <li><router-link to="/modify-article">Modifier un article</router-link></li>
            </ul>
          </li>
          <li><router-link to="/add-location">Panier</router-link></li>
          <li>
            <button class="logout-btn" @click="logout">Déconnexion</button>
          </li>
        </ul>
      </nav>
    </header>

    <div class="form-container">
      <h2>Ajouter un Article</h2>
      <form @submit.prevent="submitArticle">
        <div class="form-group">
          <input
            type="text"
            v-model="newArticle.nom_article"
            placeholder="Nom de l'article"
            required
          />
        </div>
        <div class="form-group">
          <textarea
            v-model="newArticle.description_article"
            placeholder="Description de l'article"
            required
          ></textarea>
        </div>
        <div class="form-group">
          <input
            type="file"
            ref="fileInput"
            @change="handleFileUpload"
            accept="image/*"
            required
          />
        </div>
        <div class="form-group">
          <input
            type="number"
            v-model="newArticle.quantite"
            placeholder="Quantité"
            min="1"
            required
          />
        </div>
        <div class="form-group">
          <input
            type="number"
            v-model="newArticle.prix"
            placeholder="Prix"
            min="0"
            required
          />
        </div>
        <button type="submit" class="submit-btn">Ajouter l'article</button>
      </form>
      <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AddArticle",
  data() {
    return {
      newArticle: {
        nom_article: "",
        description_article: "",
        image_article: null,
        quantite: 0,
        prix: 0,
      },
      successMessage: "",
    };
  },
  methods: {
    handleFileUpload(event) {
      this.newArticle.image_article = event.target.files[0];
    },
    async submitArticle() {
      try {
        const API_URL = process.env.VUE_APP_API_URL;
        const formData = new FormData();
        formData.append("nom_article", this.newArticle.nom_article);
        formData.append("description_article", this.newArticle.description_article);
        formData.append("image_article", this.newArticle.image_article);
        formData.append("quantite", this.newArticle.quantite);
        formData.append("prix", this.newArticle.prix);

        await axios.post(`${API_URL}/api/articles`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        this.successMessage = "L'article a été ajouté avec succès !";
        this.resetForm();
      } catch (error) {
        console.error("Erreur lors de l'ajout de l'article :", error);
        alert("Une erreur est survenue. Veuillez réessayer.");
      }
    },
    resetForm() {
      this.newArticle = {
        nom_article: "",
        description_article: "",
        image_article: null,
        quantite: 0,
        prix: 0,
      };
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    logout() {
      console.log("Déconnexion");
    },
  },
};
</script>

<style scoped>
.form-container {
  max-width: 600px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #fff;
}
.form-group {
  margin-bottom: 15px;
}
textarea,
input {
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.submit-btn {
  padding: 10px 20px;
  font-size: 16px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.submit-btn:hover {
  background: #0056b3;
}
.success-message {
  color: green;
  margin-top: 10px;
  font-weight: bold;
}
</style>
